import { getDefaultConfig, getDefaultWallets } from '@rainbow-me/rainbowkit';
import { injected, walletConnect } from 'wagmi/connectors';
import { mainnet, goerli } from 'wagmi/chains';
import { http } from 'viem';
import { ALCHEMY_ID, GOERLI_ID } from '../app/globals';
import { createConfig } from 'wagmi';

export const config = createConfig({
  chains: [mainnet, goerli],
  connectors: [
    injected(), // Auto-detect any injected wallet (MetaMask, Rabby, etc.)
    walletConnect({
      projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || 'YOUR_PROJECT_ID',
    }),
  ],
  transports: {
    [mainnet.id]: http(`https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`),
    [goerli.id]: http(`https://eth-goerli.g.alchemy.com/v2/${GOERLI_ID}`),
  },
  ssr: false,
});
